import { ChangeDetectionStrategy, Component, computed, ElementRef, inject, OnInit, viewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';

import { EditLayerBookmarkedAttributesComponent } from '@connect-services/client/components/edit-layer-bookmarked-attributes/edit-layer-bookmarked-attributes.component';
import { AbstractLayerDetailComponent } from '@connect-services/client/components/project-settings/abstract-layer-detail.component';
import {
    BookmarkedColumnFormType,
    EditLayerTemplateComponent,
    LayerFormType,
    WIDTH_PX_BREAKPOINT,
} from '@connect-services/client/components/project-settings/edit-layer-template/edit-layer-template.component';
import { SlideToggleFormControlComponent } from '@connect-services/client/components/slide-toggle/slide-toggle-form-control.component';
import { LayerAttribute, UpdateLayerDto } from '@connect-services/client/sdk/api';
import { ValidatorsService } from '@connect-services/client/services/validators.service';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { LoadingComponent } from '@shared/client/components/loading/loading.component';
import { FormService } from '@shared/client/services/form.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        EditLayerBookmarkedAttributesComponent,
        EditLayerTemplateComponent,
        LoadingComponent,
        RessourcesModule,
        SlideToggleFormControlComponent,
    ],
    selector: 'app-edit-interstandard-layer',
    styleUrl: '../edit-deposit-layer/edit-deposit-layer.component.scss',
    templateUrl: './edit-interstandard-layer.component.html',
})
export class EditInterstandardLayerComponent extends AbstractLayerDetailComponent implements OnInit {
    protected readonly formDiv = viewChild.required<ElementRef<HTMLInputElement>>('formDiv');
    protected readonly formService = inject(FormService);
    protected readonly isWide = computed(
        () =>
            this.detailPanelService.expandedVertically() &&
            this.formDiv().nativeElement.offsetWidth > WIDTH_PX_BREAKPOINT,
    );

    public override getUpdateLayerDto(): UpdateLayerDto {
        return {
            bookmarkedColumns: this.getSortedBookmarkedColumnNames(),
            isVisible: this.formGroup()!.value.isVisible,
            name: this.formGroup()!.value.name,
            order: this.formGroup()!.value.order,
        };
    }

    public async ngOnInit(): Promise<void> {
        await this.setDataAttributes();
        this.formGroup.set(this.initFormGroup());
    }

    public override updateFormGroup(formGroup: FormGroup<LayerFormType>): FormGroup<LayerFormType> {
        formGroup.addControl(
            'bookmarkedColumns',
            new FormArray<FormGroup<BookmarkedColumnFormType>>(
                this.dataAttributes()!.map(
                    (attribute: LayerAttribute, index: number) =>
                        new FormGroup<BookmarkedColumnFormType>({
                            column: new FormControl(attribute.column, { nonNullable: true }),
                            isBookmarked: new FormControl(attribute.isBookmarked, { nonNullable: true }),
                            order: new FormControl(attribute.isBookmarked ? index + 1 : null),
                        }),
                ),
                [
                    ValidatorsService.hasBookmarkedOrderValidator,
                    ValidatorsService.rangeValidator,
                    ValidatorsService.uniqueOrderValidator,
                ],
            ),
        );

        return formGroup;
    }
}
